<template>
    <div>
        <a v-if="!loading" class="btn-link text-center font-weight-bold" @click="submit">Cancel subscription</a>
        <pulse-loader v-if="loading" :loading="true" :color="'#143642'" :size="'10px'"></pulse-loader>
        <div v-if="errors && !Array.isArray(errors)" class="alert alert-error mb-2">{{errors}}</div>
    </div>
</template>

<script>
    import Subscriptions from '../../Subscriptions'
    import MixinModal from '../../../mixins/modal'
    import {axiosWeb} from "@/js/axios";
    import {mapGetters} from "vuex";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

    export default {
        name: 'CatUxoBillingCancelSubscription',
        components: {
            Subscriptions,
            PulseLoader,
        },
        props: {},
        mixins: [MixinModal],
        data() {
            return {
                loading: false,
                selectedPlan: null,
                errors: [],
            }
        },
        computed: {
            ...mapGetters('user', {
                user: 'activeUser'
            }),
        },
        methods: {
            submit() {
                let confirm = window.confirm("Are you sure you want to cancel your subscription?");
                let $this = this;

                if (confirm) {
                    $this.loading = true;

                    return axiosWeb.post(`/api/v1/cancel-subscription-end`, {
                        customer: this.user.stripe_id,
                    }).then(response => {
                        this.$store.dispatch('user/setUser', {
                            user: response.data.user
                        });

                        $this.loading = false;

                        $this.$emit('success');

                        setTimeout(() => $this.subscriptionCancelled = false, 4000);

                        window.location.reload();
                    }).catch((error) => {
                        $this.loading = false;

                        $this.$emit('error');

                        if (error.response.status === 422) {
                            $this.errors = error.response.data.errors;
                        }

                        if (error.response.status === 500) {
                            $this.errors = 'Subscription package could not be changed.';
                            // setTimeout(() => this.errors = false, 2000);
                        }
                    })
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @include media-breakpoint-down(sm) {
        .btn,
        .btn-form,
        .btn-link {
            width: 100%;
            max-width: 100%;
        }

        .card__subscription {
            text-align: center;
        }
    }

    @include media-breakpoint-between(md, lg) {
        .btn {
            font-size: rem(16px);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/CancelSubScription.vue